document.addEventListener('click', function(event) {
  const button = event.target.closest('button[type="submit"], input[type="submit"]');
  if (!button) return;

  const requiredFields = document.querySelectorAll('.product__customization input[required]');
  if (requiredFields.length === 0) return;

  let hasError = false;

  requiredFields.forEach(function(field) {
    field.classList.remove('mm-field-error');
    if (field.value.trim() === '') {
      hasError = true;
      field.classList.add('mm-field-error');
    }
  });

  if (hasError) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const firstError = document.querySelector('.mm-field-error');
    if (firstError) {
      firstError.focus();
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}, true);